module.exports = __webpack_public_path__ + "img/media (19).57b83a10.png";